import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import DocumentNotAvaibleIllustration from '../../assets/images/document-not-avaiable-illustration.svg';
import { contentSharingLinkValidationError } from '../../constant';

const SharingLinkValidationError = () => {
  return (
    <Grid container spacing="40px" sx={{ padding: '64px 34px 64px 34px' }}>
      <Grid item xs={12} sm={3} md={4} lg={3} container direction="column">
        <Typography
          data-test-id="sharing-link-validation-error-heading"
          variant="h5"
          sx={{ marginBottom: '33px' }}
        >
          {contentSharingLinkValidationError.heading}
        </Typography>
        <Typography
          data-test-id="sharing-link-validation-error-body1"
          variant="body1"
          sx={{ marginBottom: '33px' }}
        >
          {contentSharingLinkValidationError.body1}
        </Typography>
        <Typography
          data-test-id="sharing-link-validation-error-body2"
          variant="body1"
          sx={{ marginBottom: '33px' }}
        >
          {contentSharingLinkValidationError.body2}
        </Typography>
      </Grid>
      <Grid item xs={8} sx={{ display: { xs: 'none', sm: 'block' } }}>
        <Box
          component="img"
          maxWidth="375px"
          marginTop="8px"
          alt="Document not avaiable"
          src={DocumentNotAvaibleIllustration}
        />
      </Grid>
    </Grid>
  );
};

export default SharingLinkValidationError;
